import { AuthenticateStatus } from '@/config';
import { useUserData } from '@/zustand';
import { Box, Grid, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { EMAIL, LOCATION_URL } from 'src/logic/constants/links';
import { PopupUtils } from 'src/logic/hooks/use-popup';
import { sm } from 'src/site-map';

const LandingFooter = ({ contactUsPopup }: { contactUsPopup: PopupUtils }) => {
  const isAuthenticated = useUserData(state => state.authenticationStatus === AuthenticateStatus.AUTHENTICATED);
  const { pathname } = useRouter();
  const onContactClick = () => {
    if (pathname === sm.contactUs.url) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      contactUsPopup.handleOpen();
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#000',
        paddingBlock: '1rem',
        color: '#fff',
      }}
    >
      <div className='page__content'>
        <Grid container spacing={2} pt={8} pb={10}>
          <Grid item xs={12} sm={12} md={6} lg={7} xl={7}>
            <img
              src={'/assets/images/logo-white.png'}
              alt='eProcurement'
              style={{ display: 'block', maxWidth: '154px' }}
            />
            <Typography mt={2} mb={1} fontSize={{ xs: 11, lg: 14 }} fontWeight={400} maxWidth={'40ch'}>
              eProcurement is a cloud based, AI powered, end-to-end data & procurement SaaS solution
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={2.5} xl={2.5}>
            <Box display={'flex'} flexDirection={'column'} alignItems={'start'}>
              <Typography
                fontSize={{ xs: 11, lg: 14 }}
                fontWeight={400}
                mb={1}
                onClick={onContactClick}
                sx={{ cursor: 'pointer' }}
              >
                Get in touch
              </Typography>
              <Link href={sm.careers.index.url} passHref>
                <a style={{ all: 'unset', cursor: 'pointer' }}>
                  <Typography fontSize={{ xs: 11, lg: 14 }} fontWeight={400} mb={1}>
                    Careers
                  </Typography>
                </a>
              </Link>
              <Link href={sm.blog.index.url} passHref>
                <a style={{ all: 'unset', cursor: 'pointer' }}>
                  <Typography fontSize={{ xs: 11, lg: 14 }} fontWeight={400} mb={1}>
                    Blog
                  </Typography>
                </a>
              </Link>
              <Link href={sm.catalogue.index.url} passHref>
                <a style={{ all: 'unset', cursor: 'pointer' }}>
                  <Typography fontSize={{ xs: 11, lg: 14 }} fontWeight={400} mb={1}>
                    {isAuthenticated ? 'Directory' : 'Explore the Solution'}
                  </Typography>
                </a>
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={2.5} xl={2.5}>
            <Typography mb={1} fontWeight={600} fontSize={{ xs: 13, lg: 16 }}>
              Contacts
            </Typography>
            <Typography fontSize={{ xs: 11, lg: 14 }} fontWeight={400} mb={1} lineHeight={1.5}>
              <a
                href={LOCATION_URL}
                target='_blank'
                rel='noreferrer noopener'
                style={{ all: 'unset', cursor: 'pointer' }}
              >
                Dubai International Financial Center
                <br />
                Dubai, UAE
              </a>
            </Typography>
            <Typography fontSize={{ xs: 11, lg: 14 }} fontWeight={400} mb={1} lineHeight={1.5}>
              <a
                href={`mailto:${EMAIL}`}
                target='_blank'
                rel='noreferrer noopener'
                style={{ all: 'unset', cursor: 'pointer' }}
              >
                {EMAIL}
              </a>
            </Typography>
          </Grid>
        </Grid>

        <Box
          display={'flex'}
          flexWrap={'wrap'}
          gap={2}
          justifyContent={'space-between'}
          alignItems={'center'}
          sx={{ opacity: 0.5 }}
        >
          <Box display={'flex'} flexWrap={'wrap'} gap={2} justifyContent={'space-between'} alignItems={'center'}>
            <Link href={sm.support.privacy_policy.url} passHref>
              <a style={{ textDecoration: 'none', color: 'inherit' }}>
                <Typography
                  fontSize={{ xs: 11, lg: 14 }}
                  fontWeight={400}
                  mb={1}
                  sx={{ cursor: 'pointer' }}
                  className='underline-on-hover'
                >
                  Privacy Policy
                </Typography>
              </a>
            </Link>
            <Link href={sm.support.terms_and_conditions.url} passHref>
              <a style={{ textDecoration: 'none', color: 'inherit' }}>
                <Typography
                  fontSize={{ xs: 11, lg: 14 }}
                  fontWeight={400}
                  mb={1}
                  sx={{ cursor: 'pointer' }}
                  className='underline-on-hover'
                >
                  Terms & Conditions
                </Typography>
              </a>
            </Link>
          </Box>

          <Typography fontSize={{ xs: 11, lg: 14 }} fontWeight={400} mb={1}>
            eProcurment © 2025. All Rights Reserved
          </Typography>
        </Box>
      </div>
    </div>
  );
};

export default LandingFooter;
